// extracted by mini-css-extract-plugin
module.exports = {"group":"css_group__1lwtc"};